import { getPerpendicularCCW } from './Side';
import { Cursor } from './Cursor';
// function dirMtxApply(mtx: DirMTX, vec: Side): Side{
//     return (vec & 1 ? ((mtx & 0b11) + ((mtx & 0b100) ? 1 : -1) ) & 0b11 : mtx & 0b11) ^ (vec & 0b10);
// }
export function dirMtxApply(mtx, vec) {
    return ((mtx & 0b11) + ((mtx & 0b100) ? -vec : vec)) & 0b11;
}
export function dirMtxProductImpl(left, right) {
    const primary = dirMtxApply(left, dirMtxApply(right, 0));
    const secondary = dirMtxApply(left, dirMtxApply(right, 1));
    if (window.debug)
        console.log(primary, secondary);
    return primary | (getPerpendicularCCW(primary) === secondary ? 0b100 : 0);
}
export function dirMtxProduct(base, ...args) {
    return args.reduce(dirMtxProductImpl, base);
}
export function dirMtxInverse(mtx) {
    return (mtx & 0b100) ? mtx : (-mtx) & 0b11;
}
export function makeDirMtx(dir, det) {
    return det ? (dir & 0b11) | 0b100 : dir & 0b11;
}
export function dirMtxApplyPt(mtx, pt) {
    return new Cursor({ x: 0, y: 0 }).step(dirMtxApply(mtx, 0 /* right */), pt.x).step(dirMtxApply(mtx, 1 /* bottom */), pt.y);
}



//////////////////
// WEBPACK FOOTER
// ./src/DirMtx.ts
// module id = 2
// module chunks = 0